export default "__VITE_ASSET__B98Lk3em__"